import { Box, NavLink, Stack, Title } from "@mantine/core";
import {
  IconArchive,
  IconCategory,
  IconChartBar,
  IconNotification,
  IconPackage,
  IconShieldBolt,
  IconTags,
  IconUsers,
} from "@tabler/icons-react";
import { Link, useLocation } from "react-router-dom";

import { useSessionStore } from "stores/userSessionStore";

const navItems = [
  {
    label: "Global Admin",
    path: "/my-accounts/global-admin",
    icon: IconNotification,
    restrictedToGlobalAdmin: true,
  },

  { label: "My Orders", path: "/my-accounts", icon: IconChartBar },
  {
    label: "Back Orders",
    path: "/my-accounts/back-orders",
    icon: IconArchive,
  },

  {
    label: "Manage Brands",
    path: "/my-accounts/manage-brands",
    icon: IconTags,
    restrictedToStaff: true,
  },
  {
    label: "Manage Categories",
    path: "/my-accounts/manage-categories",
    icon: IconCategory,
    restrictedToStaff: true,
  },
  {
    label: "Manage Products",
    path: "/my-accounts/manage-products",
    icon: IconPackage,
    restrictedToStaff: true,
  },
  {
    label: "Manage Users",
    path: "/my-accounts/manage-users",
    icon: IconUsers,
    restrictedToAdmin: true,
  },
  {
    label: "Change Password",
    path: "/my-accounts/change-password",
    icon: IconShieldBolt,
  },
];

const AccountSidebar = () => {
  const location = useLocation();
  const { isAdmin, isStaff, isGlobalAdmin } = useSessionStore();

  const visibleItems = navItems.filter((item) => {
    if (item.restrictedToGlobalAdmin) return isGlobalAdmin;
    if (item.restrictedToStaff) return isStaff;
    if (item.restrictedToAdmin) return isAdmin;
    return true;
  });

  return (
    <Box
      w="100%"
      h="100%"
      p="md"
      bg="blue.0"
      mih="75vh"
      style={{
        borderRight: "1px solid #dee2e6",
        flexShrink: 0, // prevents sidebar from shrinking
      }}
    >
      <Title order={4} mb="md">
        My Account
      </Title>
      <Stack gap="xs">
        {visibleItems.map(({ label, path, icon: Icon }) => (
          <NavLink
            key={path}
            label={label}
            component={Link}
            to={path}
            active={location.pathname === path}
            leftSection={<Icon size={16} />}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default AccountSidebar;
